import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	errorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeButtonTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	missingResolvePermissionErrorgFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	missingEditPermissionErrorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	missingPermissionsErrorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorFlagTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorFlagTitle: {
		id: 'software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-title',
		defaultMessage: "Can't remove this issue from version",
		description: 'Flag title for failure to remove issue',
	},
	errorFlagDescription: {
		id: 'software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-description',
		defaultMessage: "We couldn't remove {issueKey} from this version. Please try again",
		description: 'Flag description for failure to update version description',
	},
	successFlagDescription: {
		id: 'software-releases-move-issues-between-versions.version-list.remove-issue-from-version.success-flag-description',
		defaultMessage: '{issueKey} has been removed from this version.',
		description: 'Flag message when issue successfully added',
	},
	removeButtonTitle: {
		id: 'software-releases-move-issues-between-versions.version-list.remove-issue-from-version.remove-button-title',
		defaultMessage: 'Remove from version',
		description: 'Title of button that will remove an issue from the current version when clicked.',
	},
	missingResolvePermissionErrorgFlagDescription: {
		id: 'software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-resolve-permission-errorg-flag-description',
		defaultMessage:
			"You don't have permission to resolve {issueKey}, so you can't remove it from the version.",
		description:
			'Flag message when issue could not be removed from the version as the user does not have resolve issue permission',
	},
	missingEditPermissionErrorFlagDescription: {
		id: 'software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-edit-permission-error-flag-description',
		defaultMessage:
			"You don't have permission to edit {issueKey}, so you can't remove it from the version.",
		description:
			'Flag message when issue could not be removed from the version as the user does not have edit issue permission',
	},
	missingPermissionsErrorFlagDescription: {
		id: 'software-releases-move-issues-between-versions.version-list.remove-issue-from-version.missing-permissions-error-flag-description',
		defaultMessage:
			"You don't have permission to edit or resolve {issueKey}, so you can't remove it from the version.",
		description:
			'Flag message when issue could not be removed from the version as the user does not have resolve and edit issue permissions',
	},
	errorFlagTitleIssueTerminologyRefreshM4: {
		id: 'software-releases-move-issues-between-versions.version-list.remove-issue-from-version.error-flag-title-issue-terminology-refresh-m4',
		defaultMessage: "Can't remove this work item from version",
		description: 'Flag title for failure to remove issue',
	},
});
export default messages;
